module.exports = {
  public: {
    key: 'public',
    label: 'Channels',
  },
  private: {
    key: 'private',
    label: 'Chats',
    defaultAlias: '#DM#',
  },
};